import script from "./AssistantWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssistantWidget.vue?vue&type=script&setup=true&lang=ts"

import "./AssistantWidget.vue?vue&type=style&index=0&id=10089b9a&scoped=true&lang=css"
import "./AssistantWidget.vue?vue&type=style&index=1&id=10089b9a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10089b9a"]])

export default __exports__